/**
 * Abstract visitor for the `abstractPeriodReportSection` hierarchy.
 *
 * @abstract
 */
export default class AbstractPeriodReportSectionVisitor extends Object {
	visit(section) {
		return section.accept(this);
	}

	visitAll(sections) {
		return sections.map((section) => this.visit(section));
	}

	visitAllEnabled(sections) {
		return this.visitAll(sections.filter((section) => section.isEnabled()));
	}

	visitAbstractPeriodReportSection(_section) {}

	visitBusinessOverviewSection(section) {
		return this.visitAbstractPeriodReportSection(section);
	}

	visitKeyfigureSection(section) {
		return this.visitAbstractPeriodReportSection(section);
	}

	visitIncomeStatementSection(section) {
		return this.visitAbstractPeriodReportSection(section);
	}

	visitBalanceSheetSection(section) {
		return this.visitAbstractPeriodReportSection(section);
	}

	visitAttachmentSection(section) {
		return this.visitAbstractPeriodReportSection(section);
	}

	visitAgedAccountsReceivablesSection(section) {
		return this.visitAbstractPeriodReportSection(section);
	}

	visitAgedAccountsPayablesSection(section) {
		return this.visitAbstractPeriodReportSection(section);
	}
}
